import React from 'react';
import {Link, RouteComponentProps} from "react-router-dom";
import "./LoginPhone.less"
import TankComponent from "../../common/component/TankComponent";
import {Button, Col, Form, Input, Row} from 'antd';
import User from "../../common/model/user/User";
import Moon from "../../common/model/global/Moon";
import {LockOutlined, NumberOutlined, PhoneFilled, UserOutlined} from '@ant-design/icons';
import Sun from "../../common/model/global/Sun";
import MessageBoxUtil from "../../common/util/MessageBoxUtil";
import Preference from "../../common/model/preference/Preference";
import Lang from "../../common/model/global/Lang";


interface IProps extends RouteComponentProps {

}

interface IState {
  phone: string;
}

export default class LoginPhone extends TankComponent<IProps, IState> {

  user: User = Moon.getSingleton().user

  constructor(props: IProps) {
    super(props);

    this.state = {
      phone: ""
    };
  }

  setPhone(e: any) {
    let value = e.target.value
    this.setState({
      phone: value
    })
  }

  componentDidMount() {

    //进入登录页面，默认退出一次
    this.logout()
  }

  //退出登录
  logout() {

    let that = this

    this.user.httpLogout(function () {
      //刷新整个网站
      Sun.updateFrame()
    })

  }

  onFinish(values: any) {


    let that = this

    let user = that.user

    user.httpLoginPhone(values["phone"], values["phonecode"], function () {
      MessageBoxUtil.success(Lang.t("user.loginSuccess"))

      that.props.history.push('/')

    })

  };

  onFinishFailed(errorInfo: any) {

  };

  onGetCode() {
    let that = this
    let user = that.user
    const {phone} = this.state

    if ( phone.length != 11 ) {
      MessageBoxUtil.error(Lang.t("user.phoneError"))
      return
    }

    user.httpLoginPhoneCode(phone, function () {
      MessageBoxUtil.success(Lang.t("user.codeSuccess"))

    })
  }

  render() {

    let that = this
    let preference: Preference = Moon.getSingleton().preference
    const {phone} = this.state

    return (
      <div className="user-login">

        <Row>
          <Col xs={{span: 24}} md={{span: 8, offset: 6}}>

            <div className="welcome">
              {Lang.t("user.welcomeLogin")}
            </div>

            <Form
              name="basic"
              initialValues={{remember: true}}
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed.bind(this)}
            >
              <Form.Item
                name="phone"
                rules={[{required: true, message: Lang.t("user.enterPhone")}]}
              >
                <Input value={phone} onChange={(e)=>{this.setPhone(e)}} size="large" placeholder={Lang.t("user.enterPhone")} prefix={<PhoneFilled/>}/>
              </Form.Item>
              <div className="getphonecode" onClick={this.onGetCode.bind(this)}>{Lang.t("user.getPhonecode")}</div>



              <Form.Item
                name="phonecode"
                rules={[{required: true, message: Lang.t("user.enterPhonecode")}]}
              >
                <Input size="large" placeholder={Lang.t("user.enterPhonecode")} prefix={<NumberOutlined/>}/>
              </Form.Item>


              <Form.Item>
                <Button type="primary" icon={<UserOutlined/>} block={true} htmlType="submit">
                  {Lang.t("user.login")}
                </Button>
              </Form.Item>

              <div className="text-right">
                <Link to={"/user/login"} className="loginuser">
                  <span className="link">{Lang.t("user.goToLogin")}</span>
                </Link>

                {
                  preference.allowRegister && (
                    <Link to={"/user/register"}>
                      <span className="link">{Lang.t("user.toToRegister")}</span>
                    </Link>
                  )
                }
              </div>


            </Form>

          </Col>
        </Row>

      </div>
    );
  }
}


